import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { APIContext } from '../../../Contexts/APIContext';
import InsightFiltersViewModel from '../../ViewModels/InsightFiltersViewModel';
import AutoCompleteFilterContainer from '../GenericFilters/Select/AutoCompleteFilterContainer';
import { InsightView } from '../../../ViewModels/InsightView';

interface ITeamManagerFilterContainerProps {
    view: InsightView;
    filters: InsightFiltersViewModel;
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>;
}

export default function TeamManagerFilterContainer({ view, filters, setFilters }: ITeamManagerFilterContainerProps) {
    const { get } = useContext(APIContext);
    const [teamManagers, setTeamManagers] = useState<string[]>([]);

    useEffect(() => {
        let controllerAction: string;
        switch (view) {
            case InsightView.Agent:
                controllerAction = 'GetAgentInsightTeamManagers';
                break;
            case InsightView.Operational:
                controllerAction = 'GetOperationalInsightTeamManagers';
                break;
            default:
                throw new Error('Unknown InsightView');
        }
        get('Insight', `${controllerAction}?client=${filters.client}`, (data) => setTeamManagers(data));
    }, [view, filters.client]);

    return (
        <>
            <AutoCompleteFilterContainer
                filters={filters}
                setFilters={setFilters}
                name={'teamManager'}
                label={'Team Manager'}
                options={teamManagers}
            />
        </>
    );
}